import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const NUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="NU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#fff"
          d="m-1.131 7.565 3.171.733L8.8 4.563l.716-.418L15.938.787l1.521-1.06-3.48-.322L8.37 2.57 4.314 4.563l-5.445 3.002Z"
        />
        <Path
          fill="#F50100"
          d="m-.853 8.01 1.708.56 15.97-8.977h-2.398L-.853 8.009Z"
        />
        <Path
          fill="#fff"
          d="m17.186 7.365.125.755-3.351.178-5.403-3.164-.51.174L-2.04.205l4.165-.801L7.693 2.48l4.356 2.104 5.137 2.781Z"
        />
        <Path
          fill="#F50100"
          d="m17.197 7.818-1.707.56-6.8-3.843-2.016-.43L-1.63-.268H.768l8.298 4.27 2.205.516 5.926 3.301Z"
        />
        <Path
          fill="#fff"
          d="M9.44 2.375h-.626V3h.625v-.625Zm7.185 0h.625V1.75h-.625v.625Zm0 3.25v.625h.625v-.625h-.625Zm-7.186 0V5h-.625v.625h.625Zm0 4v.625h.626v-.625h-.626Zm-2.844 0H5.97v.625h.625v-.625Zm0-4h.625V5h-.625v.625Zm-7.22 0h-.625v.625h.625v-.625Zm0-3.25V1.75h-.625v.625h.625Zm7.22 0V3h.625v-.625h-.625Zm0-3v-.625H5.97v.625h.625Zm2.844 0h.626v-.625h-.626v.625Zm-1.594 6.25V5H7.22v.625h.625Zm0 2.75H7.22V9h.625v-.625Zm.344 0V9h.625v-.625H8.19Zm0-2.75h.625V5H8.19v.625Zm1.25-1.25h-.625V5h.625v-.625Zm5.936 0V5H16v-.625h-.625Zm0-.75H16V3h-.625v.625Zm-5.936 0V3h-.625v.625h.625Zm-1.594.75H7.22V5h.625v-.625Zm.344 0V5h.625v-.625H8.19Zm0-.75h.625V3H8.19v.625Zm-.344 0V3H7.22v.625h.625Zm-7.22.75H0V5h.625v-.625Zm5.97 0V5h.625v-.625h-.625Zm0-.75h.625V3h-.625v.625Zm-5.97 0V3H0v.625h.625Zm7.22-1.25H7.22V3h.625v-.625Zm.344 0V3h.625v-.625H8.19Zm0-1.75h.625V0H8.19v.625Zm-.344 0V0H7.22v.625h.625Zm1.594 1.75V3h7.186V1.75H9.439v.625Zm7.186 0H16v3.25h1.25v-3.25h-.625Zm0 3.25V5H9.439v1.25h7.186v-.625Zm-7.186 0h-.625v4h1.251v-4h-.626Zm0 4V9H6.595v1.25h2.844v-.625Zm-2.844 0h.625v-4H5.97v4h.625Zm0-4V5h-7.22v1.25h7.22v-.625Zm-7.22 0H0v-3.25h-1.25v3.25h.625Zm0-3.25V3h7.22V1.75h-7.22v.625Zm7.22 0h.625v-3H5.97v3h.625Zm0-3V0h2.844v-1.25H6.595v.625Zm2.844 0h-.625v3h1.251v-3h-.626Zm-1.594 6.25H7.22v2.75h1.25v-2.75h-.625Zm0 2.75V9h.344V7.75h-.344v.625Zm.344 0h.625v-2.75h-1.25v2.75h.625Zm0-2.75V5h-.344v1.25h.344v-.625Zm1.25-1.25V5h5.936V3.75H9.439v.625Zm5.936 0H16v-.75h-1.25v.75h.625Zm0-.75V3H9.439v1.25h5.936v-.625Zm-5.936 0h-.625v.75h1.251v-.75h-.626Zm-1.594.75V5h.344V3.75h-.344v.625Zm.344 0h.625v-.75h-1.25v.75h.625Zm0-.75V3h-.344v1.25h.344v-.625Zm-.344 0H7.22v.75h1.25v-.75h-.625Zm-7.22.75V5h5.97V3.75H.625v.625Zm5.97 0h.625v-.75H5.97v.75h.625Zm0-.75V3H.625v1.25h5.97v-.625Zm-5.97 0H0v.75h1.25v-.75H.625Zm7.22-1.25V3h.344V1.75h-.344v.625Zm.344 0h.625V.625h-1.25v1.75h.625Zm0-1.75V0h-.344v1.25h.344V.625Zm-.344 0H7.22v1.75h1.25V.625h-.625Z"
        />
        <Path
          fill="#F50100"
          d="M8.846 3H17v2H8.846v4.666H7.154V5H0V3h7.154V-.667h1.692V3Z"
        />
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M8.025 5.3a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m8.05 4.346-.649.451.229-.756L7 3.563l.79-.016.26-.747.26.747.79.016-.63.478.229.756-.649-.451ZM3.55 4.288l-.54.376.19-.63-.525-.398.659-.014L3.55 3l.216.622.659.014-.525.398.19.63-.54-.376ZM12.55 4.288l-.54.376.19-.63-.525-.398.659-.014L12.55 3l.216.622.659.014-.525.398.19.63-.54-.376ZM8.05 1.888l-.54.376.19-.63-.525-.398.659-.014L8.05.6l.216.622.66.014-.526.398.19.63-.54-.376ZM8.05 7.188l-.54.377.19-.631-.525-.398.659-.014.216-.622.216.622.66.014-.526.398.19.63-.54-.376Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
